import HotelDistance from './HotelDistance.component';
export default HotelDistance;